<template>
  <div class="redact_container">
    <el-button class="top_btn" @click="addClick">新增</el-button>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      highlight-current-row
      @selection-change="handleSelectionChange"
      stripe
      border
      v-loading="tableLoading"
    >
      <el-table-column type="selection" width="55" align="center">
      </el-table-column>
      <el-table-column type="index" label="序号" width="55" align="center">
      </el-table-column>
      <el-table-column property="insuranceSn" label="保险单号">
      </el-table-column>
      <el-table-column property="insuranceTypeStr" label="保险种类">
      </el-table-column>
      <el-table-column property="insuranceCompany" label="保险公司">
      </el-table-column>
      <el-table-column property="insuranceMoney" label="责任限额">
      </el-table-column>
      <el-table-column property="startTime" label="开始时间"> </el-table-column>
      <el-table-column property="endTime" label="到期时间"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="goRedact(scope.row)">编辑</el-button>
          <el-button type="text" @click="goDetele(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="paging_box">
      <!--  :current-page="currentPage4" -->
      <el-pagination
        size-change="handleSizeChange"
        background
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="tableParams.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <v-addInsuranceDate
      :dialogShow.sync="addInsuranceDateShow"
      :carId="tableParams.id"
    ></v-addInsuranceDate>
    <v-redactInsuranceDate
      :dialogShow.sync="redactInsuranceDateShow"
      :carId="tableParams.id"
      :dialogData="redactInsuranceDateData"
    ></v-redactInsuranceDate>
  </div>
</template>

<script>
import addInsuranceDate from "./tabDialog/addInsuranceDate.vue";
import redactInsuranceDate from "./tabDialog/redactInsuranceDate.vue";
export default {
  name: "",
  data() {
    return {
      tableData: [],
      total: 0,
      tableLoading: false,
      addInsuranceDateShow: false,
      redactInsuranceDateShow: false,
      redactInsuranceDateData: {},
      multipleSelection: [],
      tableParams: {
        id: 0,
        page: 1,
        limit: 10,
      },
    };
  },
  components: {
    "v-addInsuranceDate": addInsuranceDate,
    "v-redactInsuranceDate": redactInsuranceDate,
  },
  props: {
    netId: Number,
  },
  created() {},
  methods: {
    getList() {
      this.tableParams.id = this.netId;
      this.tableLoading = true;
      this.$http.getCarInsuranceList(this.tableParams).then((res) => {
        this.tableLoading = false;
        if (res.code === 0) {
          this.tableData = res.data;
          this.total = res.count;
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message.info(res.msg);
        }
      });
    },
    addClick() {
      this.addInsuranceDateShow = true;
    },
    handleSelectionChange(e) {
      this.multipleSelection = val;
    },
    goRedact(row) {
      this.redactInsuranceDateShow = true;
      this.redactInsuranceDateData = row;
    },
    goDetele(row) {
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http.deleteInsurance({ id: row.id }).then((res) => {
            if (res.code === 0) {
              this.getList();
              this.$message({
                type: "success",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style lang="less" scoped>
@import "./redact.less";
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carTechnology_component/redact_insuranceDate.vue